<template>
	<div id="app">
		<Header />
		<router-view :key="$route.path"/>
	</div>
</template>

<script>

import Header from './components/Header.vue'
export default {
	name: "app",
	components: {
		Header
	}
}
</script>

<style lang="stylus">
BODY
	background: #f2f3f5
#app
	font-family: 'Avenir', Helvetica, Arial, sans-serif
	-webkit-font-smoothing: antialiased
	-moz-osx-font-smoothing: grayscale
	text-align: center
	color: #2c3e50
</style>
